import cn from 'classnames'
import React from 'react'

import styles from './MenuItem.module.scss'

interface MenuItemProps extends React.HTMLAttributes<HTMLDivElement> {
  before?: React.ReactNode
  after?: React.ReactNode
  children?: React.ReactNode
  disabled?: boolean
}

function MenuItem(
  { before, after, children, className, disabled, ...props }: MenuItemProps,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  return (
    <div
      ref={ref}
      aria-disabled={disabled}
      className={cn(styles.root, disabled && styles.disabled, className)}
      {...props}
    >
      {before && <span className={styles.before}>{before}</span>}
      <span className={styles.content}>{children}</span>
      {after && <span className={styles.after}>{after}</span>}
    </div>
  )
}

export default React.forwardRef<HTMLDivElement, MenuItemProps>(MenuItem)
